import { render, staticRenderFns } from "./SiteRiskTable.vue?vue&type=template&id=47a721da&"
import script from "./SiteRiskTable.vue?vue&type=script&lang=js&"
export * from "./SiteRiskTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports